import { formatNoticeLocal, PRIORITY_THEME } from "./noticeTheme";

export default function NoticeList({ items, emptyText = "No notices." }) {
  if (!items?.length) {
    return <p style={{ fontSize: 14, color: "#6b7280" }}>{emptyText}</p>;
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {items.map((n) => {
        const theme = PRIORITY_THEME[n.priority] || PRIORITY_THEME.normal;
        return (
          <article
            key={n.notice_id}
            style={{
              border: `1px solid ${theme.border}`,
              borderLeft: `4px solid ${theme.fg}`,
              borderRadius: 8,
              background: "#fff",
              overflow: "hidden",
            }}
          >
            <header style={{ padding: "10px 12px", background: theme.bg }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: theme.fg, textTransform: "uppercase" }}>
                {n.kind === "maintenance" ? "Maintenance" : "Information"} · {theme.label}
                {n.blocking ? " · Portal blocked" : ""}
              </div>
              <h3 style={{ margin: "4px 0 0", fontSize: 16, color: theme.fg }}>{n.title}</h3>
            </header>
            <div
              style={{ padding: "10px 12px", fontSize: 14, lineHeight: 1.5 }}
              dangerouslySetInnerHTML={{ __html: n.body_html || "" }}
            />
            {(n.event_starts_at || n.event_ends_at) && (
              <div style={{ padding: "0 12px 10px", fontSize: 12, color: "#6b7280" }}>
                Event: {formatNoticeLocal(n.event_starts_at)} – {formatNoticeLocal(n.event_ends_at)}
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
}
